import { Shop, Terminology, Term } from "@/types/v2";
import { useMemo } from "react";
import { shop as shopRepository } from "@/repositories/shop";
import { showErrorToast, showSuccessToast } from "@/lib/toast";
import { TerminologyList } from "@/components/Settings/Shop/TerminologyList";
import { defaultTerminology } from "@/contexts/TerminologyContext";

type TerminologySettingsProps = {
  shopData: Shop;
  syncWithSource: () => void;
};

export const TerminologySettings = ({
  shopData,
  syncWithSource,
}: TerminologySettingsProps) => {
  const shopId = useMemo(() => shopData.id, [shopData]);

  const terminology = useMemo(() => {
    return { ...defaultTerminology, ...shopData?.shopConfig?.terminology };
  }, [shopData]);

  const handleSaveTerm = async (key: keyof Terminology, term: Term) => {
    if (!shopId) return;

    const updatedTerminology = { ...terminology, [key]: term };

    shopRepository
      .updateTerminology(shopId, updatedTerminology)
      .then(() => {
        showSuccessToast(
          "Terminology Updated",
          "The terminology has been updated successfully."
        );
        syncWithSource();
      })
      .catch((err: Error) => {
        console.error("An error occurred updating terminology: ", err);
        showErrorToast(
          "Terminology Failed to Update",
          `An error occurred updating terminology: ${err.message}`
        );
      });
  };

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-lg font-semibold">Terminology Settings</h2>
      <p className="text-sm text-gray-500">
        Customize the terminology used throughout Shop Hero. Where applicable,
        the text you enter will be used in place of the default text. The
        default text is the title of each section.
      </p>
      <TerminologyList terminology={terminology} onEdit={handleSaveTerm} />
    </div>
  );
};
